import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const GuestCounter = styled.span`
  margin: 10px 0;
  width: 100%;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 16px;
  grid-area: 'guest-counter';
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const OptionalIndicator = styled.span`
  opacity: 0.7;
`;

export const GuestRow = styled.div`
  margin: 20px 0;
  min-width: 100px;
  position: relative;

  ${media.sm`
    display: flex;
    flex-direction: column; 
    padding: 16px 0;
    border-bottom: none;
    margin: 0;
  `};
`;

export const InputsRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 8px 0;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: column;

  ${media.sm`
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  `}

  ${media.md`
    display: grid;
    grid-template-columns: repeat(3, 1fr) min-content;
    grid-template-areas:
      'guest-counter guest-counter guest-counter guest-counter'
      'title-column forename-column surname-column remove-guest-button'
      'gender-column gender-column gender-column gender-column';
  `}
`;

export const RemoveGuestButtonWrapper = styled.div`
  grid-area: remove-guest-button;
`;

export const GuestColumn = styled.div`
  flex-grow: 1;
  padding: 0 16px 10px 0;
  width: 100%;
  ${media.md`
    max-width: 200px;
  `};
`;

export const TitleColumn = styled(GuestColumn)`
  grid-area: title-column;
`;

export const ForenameColumn = styled(GuestColumn)`
  grid-area: forename-column;
`;

export const SurnameColumn = styled(GuestColumn)`
  grid-area: surname-column;
`;

export const GenderColumn = styled(GuestColumn)`
  grid-area: gender-column;
  ${media.md`
    max-width: unset;
  `};
`;

export const AddButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
`;

export const RadioWrapper = styled.div`
  display: flex;
`;
